var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-col tw-bg-gray-100 tw-p-2 tw-rounded"},[_c('span',{staticClass:"tw-font-bold tw-text-gray-500"},[_vm._v("\n    "+_vm._s(_vm.meeting.meeting_date)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"tw-text-sm tw-text-gray-500"},[_vm._v(_vm._s(_vm.summaryPreview))])])
}
var staticRenderFns = []

export { render, staticRenderFns }